import React from "react";
import { withTranslation } from "react-i18next";
import BaseDialog from "../../../../../../components/dialogs/baseDialog/BaseDialog";

const DeleteDeniedUrlDialog = props => (
  <BaseDialog
    show={props.show}
    onHide={props.onHide}
    size="xs"
    title={props.t("SingleNetworkProfile.DeniedUrlsTab.DeleteModal.Title")}
    dialogApiError={props.dialogApiError}
    body={(<p>{props.t("SingleNetworkProfile.DeniedUrlsTab.DeleteModal.Text")}</p>)}
    leftButtonVariant="black"
    rightButtonVariant="red"
    leftButtonText={props.t("DialogCancel")}
    leftButtonCallback={props.onHide}
    rightButtonText={props.t("SingleNetworkProfile.DeniedUrlsTab.DeleteModal.Confirm")}
    rightButtonCallback={props.onSubmit}
  />
);

export default withTranslation()(DeleteDeniedUrlDialog);
